// removed by extract-text-webpack-plugin
module.exports = {"container-full-nosub":"app-pages-Employees-__Employee___1Jr44","container":"app-pages-Employees-__Employee___9_dBL"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Employee.css
// module id = 2086
// module chunks = 0